module.exports = __webpack_public_path__ + "img/logo-el-eden.0a4f14ab.png";